import { uipApiInstance } from '../index';

export const mpgoalcalculator = async (data: any, headers: any) => {
    try {
        const response = await uipApiInstance({
            method: 'POST',
            url: '/api/advice/mpgoalcalculator',
            withCredentials: false,
            data,
            headers
        });
        return response?.data;
    } catch (err) {
        console.error('Error in mpgoalcalculator service call:', err);
        return { error: err };
    }
};
